import { ApiRoutes } from '../constant/api';
import { api } from '../helpers/axios';
import { TDate, TDateRange } from '../types/app.types';
import {
	BookingObjectKinds,
	IAvailableObjects,
	IBookingAvaliableObjects,
	IBookingObjectTypesResponse,
	IObject,
	IObjectActionsResponce,
	IObjectLoad,
	IObjectRequest,
	IObjectsResponseType,
	TBookingObjectFetchType,
} from '../types/bookingObjects.types';

export const bookingObjectsApi = {
	getObjectById: (parentId: number) =>
		api.get(`${ApiRoutes.Objects}/${parentId}`).then((res) => res.data as IObjectsResponseType),
	getAllObjects: () =>
		api.get(ApiRoutes.Objects).then((res) => (res.data as IObjectsResponseType)?.objects),
	getRootObjects: () =>
		api.get(`${ApiRoutes.Objects}/root`).then((res) => (res.data as IObjectsResponseType)?.objects),
	getChildrenObjects: (rootObjectId: number, recursive?: boolean) =>
		api
			.get(`${ApiRoutes.Objects}/${rootObjectId}/children`, {
				params: {
					recursive,
				},
			})
			.then((res) => res.data as IObjectsResponseType),
	getObjectsForBooking: (parentId: string, date: TDateRange, clientId: number) =>
		api
			.get(`${ApiRoutes.Objects}/${parentId}/for_booking`, {
				params: {
					from: date[0],
					till: date[1],
					client_id: clientId,
				},
			})
			.then((res) => res.data as IAvailableObjects),

	getObjectLoad: (objectId: number, date: TDateRange) =>
		api
			.get(`${ApiRoutes.Objects}/${objectId}/load`, {
				params: {
					start: date[0],
					finish: date[1],
				},
			})
			.then((res) => (res.data as IObjectLoad)?.places),
	getAvailableBookingObjects: (
		parentId: number,
		query?: {
			start?: TDate;
			finish?: TDate;
			objectKind?: BookingObjectKinds;
			fetchType?: TBookingObjectFetchType;
		},
	) =>
		api
			.get(`${ApiRoutes.Objects}/${parentId}/avaliable`, {
				params: query,
			})
			.then((res) => res.data as IBookingAvaliableObjects),
	getObjectParents: (objectId: number) =>
		api.get(`${ApiRoutes.Objects}/${objectId}/hierarchy`).then((res) => res.data as IObject),
	getCabinetKeys: () => api.get(`${ApiRoutes.Objects}/cabinet_keys`),
	getCommunalPlaces: (parentId: number) =>
		api
			.get(`${ApiRoutes.Objects}/${parentId}/communal`)
			.then((res) => res.data as IObjectsResponseType),
	getObjectsTypes: () =>
		api.get(ApiRoutes.BookingObjectTypes).then((res) => res.data as IBookingObjectTypesResponse),
	createObject: (payload: IObjectRequest) => api.post(ApiRoutes.Objects, payload),
	updateObject: ({ payload, id }: { payload: IObjectRequest; id: number }) =>
		api.put(`${ApiRoutes.Objects}/${id}`, payload),
	deleteObject: (id: number) => api.delete(`${ApiRoutes.Objects}/${id}`),
	uploadObjectImage: ({ payload, id }: { payload: File; id: number }) =>
		api.post(`${ApiRoutes.Objects}/${id}/image`, payload, {
			params: { display_name: payload.name },
			headers: { 'Content-Type': 'image/svg+xml' },
		}),
	getObjectsActions: (id: number | undefined) =>
		api
			.get<IObjectActionsResponce>(ApiRoutes.BookingObjectActions, {
				params: {
					id: id,
				},
			})
			.then((res) => res.data),
};
